export const formatPhoneNumber = (value: string): string => {
    const cleanedValue = value;
    // .replace(/[^\d+/-]/g, "");

    return cleanedValue;
};
